'use client';

import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import type React from 'react';
import type { JSX } from 'react';
import Tooltip from '../../../tooltip';
import Content from './components/content';
export type RadioSelectOptionFields = {
  title: string | JSX.Element;
  description?: string;
  IconComponent: Icon;
  value: string;
  disabled?: boolean;
  disabledHint?: string;
};
export type GroupedRadioSelectOptionFields = {
  label: string;
  options: RadioSelectOptionFields[];
};
export type RadioSelectOptionProps = RadioSelectOptionFields & {
  onClick: (value: string) => void;
  selected: boolean;
  size?: 'compact' | 'default';
};
const RadioSelectOption = t0 => {
  const $ = _c(13);
  const {
    value,
    title,
    description,
    selected,
    disabled,
    disabledHint,
    size: t1,
    onClick,
    IconComponent
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== onClick || $[1] !== value) {
    t2 = event => {
      event.stopPropagation();
      onClick(value);
    };
    $[0] = onClick;
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClick = t2;
  let t3;
  if ($[3] !== IconComponent || $[4] !== description || $[5] !== disabled || $[6] !== disabledHint || $[7] !== handleClick || $[8] !== selected || $[9] !== size || $[10] !== title || $[11] !== value) {
    t3 = disabled && disabledHint ? <Tooltip disabled={!disabledHint} content={disabledHint} fullWidth={true}><Content description={description} disabled={disabled} IconComponent={IconComponent} selected={selected} size={size} title={title} value={value} /></Tooltip> : <Content description={description} disabled={disabled} IconComponent={IconComponent} key={value} onClick={handleClick} selected={selected} size={size} title={title} value={value} />;
    $[3] = IconComponent;
    $[4] = description;
    $[5] = disabled;
    $[6] = disabledHint;
    $[7] = handleClick;
    $[8] = selected;
    $[9] = size;
    $[10] = title;
    $[11] = value;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default RadioSelectOption;